import { useEffect } from 'react';

const useToggleDisplayForSpinner = (isFetching: boolean) => {
  useEffect(() => {
    const spinnerParent = document.querySelector('.spinner-container');

    const spinnerTable = document.querySelector('.spinner-contaier-for-table');

    if (spinnerTable) {
      spinnerParent?.setAttribute('style', 'display:none;');
    } else {
      spinnerParent?.setAttribute('style', 'display:block;');
    }
  }, [isFetching]);
};
export default useToggleDisplayForSpinner;
